<template>
  <CommonPages id="privacy-policy" :class="['resources-page']" titlePrefix="Privacy Policy"
    :metaDescription="domainConfig?.['meta']?.des || 'Privacy Policy'">

    <div class="resources-row">
      <div class="resources">
        <!-- 页面主标题 -->
        <h2 class="resources__title">Privacy Policy</h2>

        <div class="resources__content">
          <p>
            At {{ domainConfig?.siteName }}, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
          </p>
        </div>

        <h3 class="resources__subtitle">1. Information We Collect</h3>
        <div class="resources__content">
          <p>We may collect information from you in the following ways:</p>
          <ul>
            <li><strong>Personal Data:</strong> If you create an account, we may collect your name, email address, and account preferences.</li>
            <li><strong>Usage Data:</strong> We automatically collect data about your interactions with our site, such as the novels you read, time spent on pages, your reading progress, and browser type.</li>
            <li><strong>Cookies and Tracking:</strong> We use cookies to enhance your experience, remember your login status, and analyze site traffic.</li>
          </ul>
        </div>

        <h3 class="resources__subtitle">2. How We Use Your Information</h3>
        <div class="resources__content">
          <p>We use the collected data to:</p>
          <ul>
            <li><strong>Personalize Your Experience:</strong> Recommend AI stories based on your reading history.</li>
            <li><strong>Improve Our AI Models:</strong> Analyze aggregated, non-identifiable reading patterns to improve our story generation and curation algorithms.</li>
            <li><strong>Communication:</strong> Send you updates about new chapters, features, or technical notices (only if you opt-in).</li>
            <li><strong>Site Maintenance:</strong> Monitor and prevent fraudulent activity or technical issues.</li>
          </ul>
        </div>

        <h3 class="resources__subtitle">3. Data Sharing and Disclosure</h3>
        <div class="resources__content">
          <p>We do not sell your personal data to third parties. We may share information only in the following cases:</p>
          <ul>
            <li><strong>Service Providers:</strong> With trusted third parties who help us host our site or analyze data (e.g., Google Analytics).</li>
            <li><strong>Legal Requirements:</strong> If required by law or to protect our rights and safety.</li>
            <li><strong>Business Transfers:</strong> In the event of a merger or sale of the platform.</li>
          </ul>
        </div>

        <h3 class="resources__subtitle">4. Data Security</h3>
        <div class="resources__content">
          <p>
            We implement industry-standard security measures to protect your information. However, please note that no method of transmission over the internet is 100% secure.
          </p>
        </div>

        <h3 class="resources__subtitle">5. Your Rights and Choices</h3>
        <div class="resources__content">
          <p>Depending on your location (such as the EU under GDPR), you may have the right to:</p>
          <ul>
            <li>Access, update, or delete the personal information we hold about you.</li>
            <li>Opt-out of marketing emails at any time.</li>
            <li>Disable cookies through your browser settings.</li>
          </ul>
        </div>

        <h3 class="resources__subtitle">6. Children's Privacy</h3>
        <div class="resources__content">
          <p>
            Our platform is not intended for children under the age of 13. We do not knowingly collect personal information from children. If we become aware that a child has provided us with data, we will delete it immediately.
          </p>
        </div>

        <h3 class="resources__subtitle">7. Third-Party Links</h3>
        <div class="resources__content">
          <p>
            Our website may contain links to other sites. We are not responsible for the privacy practices or content of those third-party websites.
          </p>
        </div>

        <h3 class="resources__subtitle">8. Changes to This Policy</h3>
        <div class="resources__content">
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated "Last Updated" date.
          </p>
        </div>

        <h3 class="resources__subtitle">9. Contact Us</h3>
        <div class="resources__content">
          <p>
            If you have any questions or concerns about this Privacy Policy, please contact us at: {{ domainConfig?.IAMEMAIL }}.
          </p>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/resources.scss'

export default {
  name: 'PrivacyPolicy',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script>
